import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { TrackingEvent } from '../../../../Services/Tracking/TrackingService';
import RadioInput from '../../Inputs/RadioInput';
import styles from './RadioButtonCardSeries.module.scss';

export interface IJoinedSelectionButtonsProps<T> {
    label?: string | JSX.Element;
    options: { label: string | JSX.Element; value: T }[];
    handleSelectionChange: (dataFrequency: T) => void;
    selection: T;
    track: TrackingEvent;
}

// eslint-disable-next-line @typescript-eslint/comma-dangle
const RadioButtonCardSeries = <T,>(props: IJoinedSelectionButtonsProps<T>) => (
    <>
        <p className={styles.radio_button_card_series_label}>{props.label}</p>
        <div className={styles.radio_button_card_series}>
            {props.options.map((x) => (
                <div
                    key={`${x.value}`}
                    className={props.selection === x.value ? styles.radio_button_card_series_selection_active : styles.radio_button_card_series_selection}
                >
                    {props.selection === x.value ? (
                        <div className={styles.radio_button_card_series_checked}>
                            <CheckCircleIcon color="primary" />
                            {x.label}
                        </div>
                    ) : (
                        <RadioInput
                            key={x.label.toString()}
                            handleIsChecked={(value) => value && props.handleSelectionChange(x.value)}
                            title={x.label}
                            isChecked={props.selection === x.value}
                            track={props.track}
                        />
                    )}
                </div>
            ))}
        </div>
    </>
);

export default RadioButtonCardSeries;
